import { useQuery } from '@tanstack/react-query';
import { getHealthCheckQueryOptions } from '../healthCheckQuery';
import { getMaintenanceStatusQueryOptions } from '../maintenanceStatusQuery';

export const useMaintenanceApi = (options?: { enabled?: boolean; refetchInterval?: number }) => {
    const {
        data: healthCheckStatus,
        isLoading: isLoadingHealthCheckStatus,
        isError: isHealthCheckError,
    } = useQuery(getHealthCheckQueryOptions(options));

    const {
        data: maintenanceStatus,
        isLoading: isLoadingMaintenanceStatus,
        isError: isMaintenanceStatusError,
    } = useQuery(getMaintenanceStatusQueryOptions(options));

    return {
        healthCheckStatus,
        maintenanceStatus,
        allowedLogins: maintenanceStatus?.allowedLogins ?? [],
        isLoadingHealthCheckStatus: isLoadingHealthCheckStatus || isLoadingMaintenanceStatus,
        isError: isHealthCheckError || isMaintenanceStatusError,
    };
};
